import React from 'react';

const Descriptionproyect = ({ data }) => {
  const { description } = data[0]
  return (
    <div className="container text-ready glass box-shadow">
      {/* <h1 className="text-morado">Description</h1> */}
      <h3 className="text-center text-white">{description}</h3>
    </div>
  );
}

export default Descriptionproyect;
